import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Wallet, Banknote } from "lucide-react";
import { WalletPage } from "@/pages/Wallet";
import { PayoutsPage } from "@/pages/Payouts";

export function EarningsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const initial = location.pathname.startsWith("/payouts")
    ? "payouts"
    : location.pathname.startsWith("/wallet")
    ? "wallet"
    : (new URLSearchParams(location.search).get("tab") === "payouts" ? "payouts" : "wallet");
  const [tab, setTab] = useState(initial);

  useEffect(() => {
    if (location.pathname === "/wallet" && tab !== "wallet") setTab("wallet");
    if (location.pathname === "/payouts" && tab !== "payouts") setTab("payouts");
  }, [location.pathname]);

  function changeTab(next) {
    setTab(next);
    const params = new URLSearchParams(location.search);
    params.set("tab", next);
    navigate(`/earnings?${params.toString()}`, { replace: true });
  }

  return (
    <div data-testid="earnings-page" className="space-y-6">
      <div>
        <h1 data-testid="earnings-title" className="page-title">Earnings</h1>
        <p className="page-subtitle">Your balance, transactions and payout requests in one place</p>
      </div>

      <Tabs value={tab} onValueChange={changeTab} className="w-full">
        <TabsList
          data-testid="earnings-tabs"
          className="inline-flex h-11 items-center justify-start rounded-full border border-[#1a1a1a] bg-[#0a0a0a] p-1 text-zinc-400"
        >
          <TabsTrigger
            value="wallet"
            data-testid="earnings-tab-wallet"
            className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-semibold transition-all data-[state=active]:bg-[#c8ff00] data-[state=active]:text-black data-[state=active]:shadow-[0_0_20px_rgba(200,255,0,0.35)]"
          >
            <Wallet size={15} /> Wallet
          </TabsTrigger>
          <TabsTrigger
            value="payouts"
            data-testid="earnings-tab-payouts"
            className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-semibold transition-all data-[state=active]:bg-[#c8ff00] data-[state=active]:text-black data-[state=active]:shadow-[0_0_20px_rgba(200,255,0,0.35)]"
          >
            <Banknote size={15} /> Payouts
          </TabsTrigger>
        </TabsList>

        <TabsContent value="wallet" className="mt-6 focus-visible:outline-none">
          <WalletPage embedded />
        </TabsContent>
        <TabsContent value="payouts" className="mt-6 focus-visible:outline-none">
          <PayoutsPage embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}
